import { TAXONOMY_BRAND_VIEW } from '../../screens/auth/constants';

export const DROPDOWNDATA = [
    {
        key: 'category',
        label: 'Category',
        id: 2,
        icon: 'icon-profile-icon',
    },
    {
        key: 'object',
        label: 'Object',
        id: 3,
        icon: 'icon-power-icon',
    },
    {
        key: 'material',
        label: 'Material',
        id: 4,
        icon: 'icon-settings-icon',
    },
    {
        key: 'brand',
        label: 'Brand',
        id: 4,
        icon: 'icon-power-icon',
        permission: TAXONOMY_BRAND_VIEW,
        isProtected: true,
    },
];
